















import { defineComponent, computed } from "@vue/composition-api";

const getNumArr = (min:number, count:number) => {
	const r = [];
	for(var i = 0; i < count; i++){ r.push(min + i); }
	return r;
};

export default defineComponent({
	emits:[ "input" ],
	props:{
		value:{
			type:Number
		},
		size:{
			type:String,
			default:"sm"
		},
		min:{
			type:Number,
			default:0
		},
		count:{
			type:Number,
			default:10
		}
	},
	setup(props, context){
		const options = computed(() => {
			return getNumArr(props.min, props.count)
			.map(num => { return { value:num, text:num }; });
		});
		const onInput = (v:any) => context.emit("input", v)
		return {
			options,
			onInput
		};
	}
});

